/* global navigator */

export const hasNavigator = typeof navigator !== "undefined";
export const hasWindow = typeof window !== "undefined";
export const platform = hasNavigator ? navigator.userAgentData?.platform || navigator.platform || "unknown" : "unknown";
export const userAgent = hasNavigator ? navigator.userAgent : "unknown";
export const vendor = hasNavigator ? navigator.vendor : "unknown";
export const isIpadPro = hasNavigator && platform === "MacIntel" && navigator.maxTouchPoints > 1;
export const isIOS = hasNavigator && (/iPad|iPhone|iPod/.test(userAgent) || isIpadPro) && !window.MSStream;
export const noHover = hasWindow ? window.matchMedia("(hover: none)").matches : false;
export const isSafariDesktop = hasNavigator && /Safari/i.test(userAgent) && /Apple Computer/.test(vendor) && !/Mobi|Android/i.test(userAgent);
export const isChromeDesktop = hasNavigator && /Chrome/i.test(userAgent) && !/Mobi|Android/i.test(userAgent);
export const supportNativeShare = hasNavigator && navigator.share && !isSafariDesktop && !isChromeDesktop;
export const isAndroidTwaApp = !!document.referrer?.startsWith("android-app://");
export const isIosApp = hasNavigator && /BirthdayAlarm|BirthdayAlarm_test/.test(userAgent);
